import {
  type OnNotifyChangeEventData,
  Step,
} from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import {
  NOTIFICATIONS_TEAM_SELECT_BACK_BTN_PRESSED,
  NOTIFICATION_WIDGET_NOTIFY_TEAM_DISPLAYED,
} from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { dispatchUpdateIncludeSendEmailStep } from 'src/app/v1/state/dispatcher/notificationsSetting';
import type { AppState } from 'src/types/appState';
import type { TrackingEvent } from 'src/types/trackingData';

import { AddTeamMembersCallout } from '../../../AddTeamMembersCallout';
import { useHandleSaveJobAccessAndNotify } from '../../hooks/useHandleSaveJobAccessAndNotify';
import { sendNotificationsImpressionEvents } from '../../utils/sendNotificationsSettingEvents';
import { StepTeamAccessPanel } from '../StepTeamAccessPanel';

import translations from './.vocab';

interface Props {
  hasNextStep?: boolean;
}
export const StepTeamAccess = ({
  hasNextStep = false,
  ...stepperProps
}: Props) => {
  const { displayAddTeamMemberLink } = useSelector(
    (state: AppState) => ({
      displayAddTeamMemberLink: state.session.userCanManageUsers,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();
  const handleSaveJobAccessAndNotify = useHandleSaveJobAccessAndNotify();

  const onSetTeamMemberBack = () => {
    const eventData: TrackingEvent = {
      eventName: NOTIFICATIONS_TEAM_SELECT_BACK_BTN_PRESSED,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };
  const onActive = () => {
    sendNotificationsImpressionEvents(
      NOTIFICATION_WIDGET_NOTIFY_TEAM_DISPLAYED,

      displayAddTeamMemberLink,
    );
  };

  const handleOnNotifyChange = (eventData: OnNotifyChangeEventData) => {
    dispatch(
      dispatchUpdateIncludeSendEmailStep(eventData.teamMemberNotifySelected),
    );
  };
  const { t } = useTranslations(translations);
  const footerNotification = displayAddTeamMemberLink ? (
    <AddTeamMembersCallout description={t('step-team-access-description')} />
  ) : null;
  return (
    <Step
      onActive={onActive}
      onClickGoBack={onSetTeamMemberBack}
      onClickNextAsync={hasNextStep ? undefined : handleSaveJobAccessAndNotify}
      footerNotification={footerNotification}
      {...stepperProps}
    >
      <StepTeamAccessPanel onNotifyChange={handleOnNotifyChange} />
    </Step>
  );
};
